// Integração para upload de arquivos (usando PHP)
import { UploadedFile } from '../../entities/UploadedFile';

// Função para obter a URL base da API
const getApiBaseUrl = () => {
  // Em desenvolvimento, use localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3007/api';
  }
  // Em produção, use o caminho relativo
  return '/api';
};

export const uploadFile = async (file, onProgress) => {
  return new Promise((resolve, reject) => {
    try {
      // Criar FormData para enviar o arquivo
      const formData = new FormData();
      formData.append('file', file);
      
      // Criar XMLHttpRequest para monitorar o progresso
      const xhr = new XMLHttpRequest();
      
      // Configurar evento de progresso
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          const percentComplete = Math.round((event.loaded / event.total) * 100);
          onProgress(percentComplete);
        }
      });
      
      // Configurar evento de conclusão
      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (error) {
            console.error('Erro ao analisar resposta:', error);
            reject(new Error('Erro ao analisar resposta do servidor'));
          }
        } else {
          console.error('Erro no upload:', xhr.status, xhr.statusText);
          reject(new Error(`Erro no upload: ${xhr.status} ${xhr.statusText}`));
        }
      });
      
      // Configurar evento de erro
      xhr.addEventListener('error', () => {
        console.error('Erro de rede no upload');
        reject(new Error('Erro de rede ao fazer upload'));
      });
      
      // Configurar evento de aborto
      xhr.addEventListener('abort', () => {
        console.warn('Upload abortado');
        reject(new Error('Upload abortado'));
      });
      
      // Abrir conexão e enviar o arquivo
      xhr.open('POST', `${getApiBaseUrl()}/upload.php`);
      xhr.send(formData);
    } catch (error) {
      console.error('Erro ao iniciar upload:', error);
      reject(error);
    }
  });
};
